import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";
import { Grid, Button } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

export const STGrid = styled(Grid)`
  && {
    margin-top: 8px;
    align-items: flex-start;
    margin-bottom: 16px;
    ${theme.breakpoints.only("xs")} {
      justify-content: center;
    }
  }
`;

export const STPageHeader = styled.h1`
  font-size: 18px;
  margin: 0;
  width: fit-content;
`;

export const STLinkButton = styled(Button)`
  && {
    text-transform: none;
  }
`;

export const STGridButtonItem = styled(Grid)`
  && {
    padding-top: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

export const STDeleteIcon = styled(DeleteIcon)`
  && {
    color: #ff0000;
  }
`;
